import React from 'react';
import HeadingDescription from '../HeadingDescription';
import PointersWithHeading from '../PointersWithHeading';
import ProposalImage from '../ProposalImage';
import TechnicalDataTable from '../TechnicalDataTable';
import defaultPtsImg from '../../../assets/images/proposal/powder_transfer_system/powder_transfer_system.jpg';

export default function PowderTransferSystemSection({ ptsContent, ptsImage, ptsTables = [], isUploadedImage = false }) {
  const resolvedImage = ptsImage || defaultPtsImg;
  const hasPts = ptsContent || ptsTables.length > 0;
  if (!hasPts) return null;

  return (
    <>
      <div className="a4-paddings quotation-page quotation-page-compact">
        <div className="quotation-page-inner quotation-bg-light">
          <div className="quotation-section-block">
            <HeadingDescription heading="Powder Transfer System" description="" level={2} />
            <HeadingDescription
              heading={ptsContent?.title || 'Powder Transfer System'}
              description={ptsContent?.description || ''}
              level={3}
            />
            <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', marginTop: 8 }}>
              {ptsContent?.items?.items && (
                <div style={{ flex: 1, minWidth: 0 }}>
                  <PointersWithHeading
                    items={ptsContent.items.items.map((it) => ({ title: it.title, description: it.description }))}
                    numbered
                  />
                </div>
              )}
              <div style={{ flexShrink: 0 }}>
                <ProposalImage
                  src={resolvedImage}
                  wrapperStyle={{ marginBottom: 0 }}
                  imgStyle={isUploadedImage ? { maxHeight: 350, width: 'auto', objectFit: 'contain' } : { width: 350, maxWidth: 350, objectFit: 'contain' }}
                />
              </div>
            </div>
            {ptsTables.map((table) => (
              <TechnicalDataTable
                key={table.id}
                data={table.data}
                headers={table.headers}
                title={table.label}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
